import * as crypto from 'crypto'

function deriveKeyFromPassphrase(
	passphrase: string,
	salt: Buffer,
	iterations: number,
	keyLength: number
): Buffer {
	return crypto.pbkdf2Sync(passphrase, salt, iterations, keyLength, 'sha256')
}

export function encryptObject(object: any, secret: string): string {
	const salt = crypto.randomBytes(16)
	const key = deriveKeyFromPassphrase(secret, salt, 10000, 32)
	const iv = crypto.randomBytes(16)
	const cipher = crypto.createCipheriv('aes-256-cbc', key, iv)
	let encrypted = cipher.update(JSON.stringify(object), 'utf8', 'hex')
	encrypted += cipher.final('hex')
	
return salt.toString('hex') + ':' + iv.toString('hex') + ':' + encrypted
}

export function decryptObject(encryptedData: string, secret: string): any {
	const [saltHex, ivHex, encryptedText] = encryptedData.split(':')
	const salt = Buffer.from(saltHex, 'hex')
	const iv = Buffer.from(ivHex, 'hex')
	const key = deriveKeyFromPassphrase(secret, salt, 10000, 32)
	const decipher = crypto.createDecipheriv('aes-256-cbc', key, iv)
	let decrypted = decipher.update(encryptedText, 'hex', 'utf8')
	decrypted += decipher.final('utf8')
	
	return JSON.parse(decrypted);
}
